
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LeagueLecturersEnrollment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"LeagueOfLecturersEnrollmentType"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"stage"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"status"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"videocard"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lectureName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lectureVideo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"agreementFile"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"agreementFilePart2"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"agreementFilePart3"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"performanceTheme"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"firstThemeOfSpeech"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"secondThemeOfSpeech"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"thirdThemeOfSpeech"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"fourthThemeOfSpeech"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"season"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LeagueLecturersSeason"},"directives":[]}]}}]}}],"loc":{"start":0,"end":387}};
    doc.loc.source = {"body":"#import \"./leagueLecturersSeason.graphql\"\n\nfragment LeagueLecturersEnrollment on LeagueOfLecturersEnrollmentType {\n  id\n  stage\n  status\n  videocard\n  lectureName\n  lectureVideo\n  agreementFile\n  agreementFilePart2\n  agreementFilePart3\n  performanceTheme\n  firstThemeOfSpeech\n  secondThemeOfSpeech\n  thirdThemeOfSpeech\n  fourthThemeOfSpeech\n  season {\n    ...LeagueLecturersSeason\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("./leagueLecturersSeason.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["LeagueLecturersEnrollment"] = oneQuery(doc, "LeagueLecturersEnrollment");
        
